import { motion } from "framer-motion";
import { HeroPhoto } from "@/components/sections/Hero";
import { PathCards } from "./PathCards";

const EASE = [0.22, 1, 0.36, 1];
const LINES = [
  { text: "New website", cls: "text-ink" },
  { text: "coming soon", cls: "text-brand" },
];

export const ComingHero = () => (
  <section className="relative overflow-hidden cad-grid pt-32 pb-20 sm:pt-40 sm:pb-24" data-testid="coming-hero">
    <div className="relative mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:gap-10">
      <div className="lg:col-span-7 lg:self-center">
        <h1 className="font-display text-[3.4rem] font-extrabold uppercase leading-[0.88] tracking-tight sm:text-7xl lg:text-8xl xl:text-[7.5rem]" data-testid="coming-headline">
          {LINES.map((l, i) => (
            <span key={l.text} className="block overflow-hidden pb-1">
              <motion.span className={`block ${l.cls}`} initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 0.9, ease: EASE, delay: 0.15 + i * 0.14 }}>
                {l.text}
              </motion.span>
            </span>
          ))}
        </h1>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-steel sm:text-lg">
          Ramor Renewables is now focused on mechanical and renewable fit-out for construction projects. Our new website is on its way.
        </p>
      </div>
      <div className="order-last lg:order-none lg:col-span-5">
        <HeroPhoto />
      </div>
      <div className="lg:col-span-12 lg:mt-6">
        <PathCards />
      </div>
    </div>
  </section>
);
